import { BusinessRelationshipLifecycle, BusinessRelationshipStatus } from 'views/CaseRedirect/CaseRedirect';

export type CoreDataDto = {
  brStoredInClm: boolean;
  businessRelationshipDto?: AccountRelationsDetailsApiDtoClm;
  accountRelationDetailsDto?: AccountRelationsDetailsApiDto;
};

type AccountRelationsDetailsApiDtoClm = {
  // partial type definition
  uid: string;
  businessRelationshipName: string;
  businessRelationshipType: BrType;
  businessRelationshipMasterNumber: string;
  businessRelationshipStatus: BusinessRelationshipStatus;
  businessRelationshipLifecycle: BusinessRelationshipLifecycle;
  businessRelationshipSubtype?: BrSubTypeFromBrMgmt;
};

type AccountRelationsDetailsApiDto = {
  // partial type definition
  brUid: string;
  accountNumber: string;
  accountName: string;
  status?: string;
};

export const BrTypes = {
  PRIVATE_BANKING: 'PRIVATE_BANKING',
  INTERMEDIARY_B2B: 'INTERMEDIARY_B2B',
} as const;

export const BrSubTypesFromBrMgmt = {
  EAM: 'EAM',
  EFA: 'EFA',
  ORIA: 'ORIA',
  STANDARD: 'STANDARD',
} as const;

export type BrType = keyof typeof BrTypes;
export type BrSubTypeFromBrMgmt = keyof typeof BrSubTypesFromBrMgmt;

export type BrSearchDto = {
  bookingCenterEntityId: string;
  busRelLifecycle: string;
  busRelMasterNumber: string;
  busRelName: string;
  busRelStatus: string;
  busRelType: BrType;
  busRelUid: string;
  businessRelationshipRoles: string[];
  modifiedTimestamp: string;
};

export const BrSubTypes = {
  DOMICILIARY_COMPANY_WITH_UNDERLYING_FOUNDATION: 'DOMICILIARY_COMPANY_WITH_UNDERLYING_FOUNDATION',
  DOMICILIARY_COMPANY_WITH_UNDERLYING_TRUST: 'DOMICILIARY_COMPANY_WITH_UNDERLYING_TRUST',
  EMPLOYEE: 'EMPLOYEE',
  FOUNDATION: 'FOUNDATION',
  LIFE_INSURANCE: 'LIFE_INSURANCE',
  TRUST: 'TRUST',
  EAM: 'EAM',
  EFA: 'EFA',
  ORIA: 'ORIA',
} as const;

export type BrSubType = keyof typeof BrSubTypes;

export const BrUserAuthorities = {
  UPDATE: 'UPDATE',
  START_BR_ONBOARDING: 'START_BR_ONBOARDING',
  PROTECTED_U_LC_OPERATING: 'PROTECTED_U_LC_OPERATING',
  PROTECTED_U_P2BR: 'PROTECTED_U_P2BR',
  PROTECTED_U_BR_ONBOARDING_AGREEMENT: 'PROTECTED_U_BR_ONBOARDING_AGREEMENT',
  FRONT_ALL_EMPLOYEE_FETCH: 'FRONT_ALL_EMPLOYEE_FETCH',
  BR_DEACTIVATE: 'BR_DEACTIVATE',
  BR_REJECT_WITHDRAW: 'BR_REJECT_WITHDRAW',
} as const;

export type BrUserAuthoritiesType = keyof typeof BrUserAuthorities;

export const BrBusinessEvents = {
  BR_DEACTIVATED: 'BR_DEACTIVATED',
  BR_WITHDRAWN: 'BR_WITHDRAWN',
  BR_REJECTED: 'BR_REJECTED',
} as const;

export type BrBusinessEventsType = keyof typeof BrBusinessEvents;

export type BrContext = {
  brType: BrType;
  busRelMasterNumber: string;
  brSubType?: BrSubType;
  busRelUid: string;
};

export type BrProfileType =
  | 'BR_DOM_CO'
  | 'BR_ICF'
  | 'BR_ICM'
  | 'BR_ICR'
  | 'BR_IM'
  | 'BR_LI'
  | 'BR_OP_CO'
  | 'BR_PI'
  | 'UNKNOWN';
